import { ContactController} from "../controller/ContactController";

class Contacts{

    constructor(){
        this.notifVariant=null;
        this.notifMessage=null;
        this.notifDescription=null;
        this.contacts=[];
    }

    //get contacts list
    getContacts= async() => {

        try{
            const response = await new ContactController().getContacts();

            if (response === undefined){

              //erreur API call
              this.notifVariant = "error";
              this.notifMessage = "API erreur: Erreur lors de la récupération des données";
              this.notifDescription = null;

            }
            else if (response.response === "200"){
                this.notifVariant=null;
                this.notifMessage=null;
                this.notifDescription = null;
                this.contacts = response.dataArray;
                return this.contacts;
            }
            else{
                this.contacts=[];

                //API return <> 200
                this.notifVariant = 'error';
                this.notifMessage = 'Erreur lors de la récupération des données';
                this.notifDescription = response.response+": "+response.responseDescription;
                return this.contacts;

            }
        }
        catch(err){
            console.log(err);
        }

    }


}
export default Contacts;
